export function getSubdomain(hostname: string): string | null {
  const host = hostname.toLowerCase()
  if (!host.endsWith("eventador.org")) return null
  const parts = host.split(".")
  if (parts.length < 3) return null
  const sub = parts[0]
  if (sub === "www") return null
  return sub
}

export function normalizeLabel(s: string): string {
  return s.toLowerCase().replace(/[^a-z0-9]+/g, "")
}
